import NearbyProjectsSection from 'components/nearby-projects-section/NearbyProjectsSection';

export default NearbyProjectsSection;
